import "./HomeLanding.scss";
import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import WistiaVideo from "../../../components/wistiaVideo/WistiaVideo";

import localmobileVideo from "../../../assets/videos/exoticmobilehome.mp4";

const HomeLanding = ({ title, para, videoId, isShow = "true", w, h }) => {
  const [textStatus, setTextStatus] = useState(false);
  const goToSecondSec = () => {
    const section = document.getElementById("second");
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [windowHeight, setWindowHeight] = useState(window.innerHeight);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
      setWindowHeight(window.innerHeight);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    setTextStatus(true);

    const timeId = setTimeout(() => {
      setTextStatus(false);
    }, 5000);

    return () => {
      clearTimeout(timeId);
    };
  }, []);

  return (
    <section className="home_landing p_b">
      {videoId && (
        <WistiaVideo
          vId={videoId}
          w={w}
          h={h}
          W={windowWidth}
          H={windowHeight}
        />
      )}
      <div className="mobile_view">
        <video hight="100%" width="100%" loop muted autoPlay>
          <source src={localmobileVideo} type="video/mp4" />
        </video>
      </div>
      {textStatus && (
        <div className="content_wrap">
          {title && (
            <h1 className="gold">
              {title
                ?.split("")
                .map((char, k) => (
                  <motion.span
                    initial={{ translateX: 24, opacity: 0 }}
                    whileInView={{ translateX: 0, opacity: 1 }}
                    transition={{
                      duration: 0.4,
                      ease: "easeInOut",
                      delay: 0.04 * k,
                    }}
                    key={k}
                  >
                    {char}
                  </motion.span>
                ))
                .concat("")}
            </h1>
          )}
          {para && <p className="gold">{para}</p>}
          {isShow && (
            <motion.div
              initial={{ scaleY: 0, opacity: 0 }}
              whileInView={{ scaleY: 1, opacity: 1 }}
              transition={{
                duration: 0.6,
                ease: "easeInOut",
                delay: 0.2,
              }}
              className="v_line"
            ></motion.div>
          )}
          <button className="mouse" onClick={goToSecondSec}>
            <span className="dot"></span>
          </button>
          <p className="scroll gold" onClick={goToSecondSec}>
            Know more
          </p>
        </div>
      )}
    </section>
  );
};

export default HomeLanding;
